module.exports = __webpack_public_path__ + "static/juvenplans.e91ab65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/juvenplans.png
// module id = 727
// module chunks = 92562407457355